/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function HsCodesList() {
  const stateRef = useRef(null);
  const history = useHistory();
  const url = `${API_URL}/products/hsCodes/get`;
  const StatefullGrid = withState(Grid, url);

  const productNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/hsCodes/edit/${dataItem.id}`}>{dataItem?.code}</Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="HsCodes"
        titleRight="Create"
        onRightHandler={(): void => history.push('/hsCodes/create')}
        iconRight={createIcon} 
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="code" title="Code" cell={(row) => productNameCell(row, stateRef)} />
          <GridColumn field="nameEn" title="English Name" />
          <GridColumn field="nameBg" title="Bulgarian Name" />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
